<template>
  <el-dialog
    v-loading="loading"
    class="access-log-modal"
    width="90%"
    :title="`${companyName}拜访日志`"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div class="logs">
      <el-timeline v-if="logs.length" :reverse="false">
        <el-timeline-item
          v-for="log in logs"
          :key="log.id"
          :timestamp="log.timestamp"
        >
          {{ log.memo }}({{ log.salerName }})
        </el-timeline-item>
      </el-timeline>
      <div v-else class="no-data">暂无数据</div>
    </div>
    <div class="actions">
      <el-button size="small" type="primary" @click="doAppend">追加</el-button>
      <el-button size="small" type="default" @click="close">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { QueryAccessLog, AppendAccessLog } from '../services'
import moment from 'moment'
export default {
  name: 'PassportModal',
  mixins: [ModalMixin],
  data () {
    return {
      loading: false,
      companyId: undefined,
      companyName: '',
      logs: []
    }
  },
  methods: {
    init (companyId, companyName) {
      this.companyId = companyId
      this.companyName = companyName
      this.loadData(companyId)
      return this.open()
    },
    loadData (companyId) {
      this.loading = true
      QueryAccessLog(companyId).then((resp) => {
        this.logs = resp.map(t => ({
          id: t.id,
          memo: t.memo,
          salerName: t.salerName,
          timestamp: moment(t.accessDate).format('YYYY-MM-DD')
        }))
      }).catch(() => {
        this.close(false)
      }).finally(() => {
        this.loading = false
      })
    },
    doAppend () {
      this.$prompt('', '请输入本次拜访摘要', {
        closeOnClickModal: false,
        inputType: 'textarea',
        inputPlaceholder: '客户需求、反馈建议、对客户的用户画像等',
        inputPattern: /\S+/,
        required: true,
        inputErrorMessage: '请输入本次拜访摘要'
      }).then(({ value }) => {
        AppendAccessLog({
          memo: value.trim(),
          companyId: this.companyId
        }).then(() => {
          this.loadData(this.companyId)
        }).catch(() => {
          this.$message.error('添加失败')
        })
      })
    }
  }
}
</script>
<style lang="stylus">
.access-log-modal
  .el-dialog
    max-width 560px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
    .logs
      margin-top 24px
    .no-data
      text-align center
      margin 36px 0
    .actions
      text-align center
      margin-top 16px
</style>
